<div class="container">
  <div class="header">
    <div class="title-text-container">
      <div fiTranslation="ALT_TEXT_REQUEST_LIST_EDIT_REQUEST"></div>
      <span class="number">{{ leadNumber }}</span>
    </div>

    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="onClosePopup()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-content">
    <div class="lead-container" [formGroup]="leadForm">

      <div class="section-text" fiTranslation="REQUEST_DETAIL_HEADER_ENQUIRY_DETAILS"></div>

      <div class="input-row">
        <fi-input type="SELECT"
          [readOnly]="!canEditFields || leadTypes?.length <= 1"
          [enableSearch]="true"
          labelKey="%ACTION_LEAD_TYPE_HEADLINE_REQUEST_TYPE%*"
          [replaceKeys]="true"
          [options]="leadTypes"
          [selectedOptionsOrValues]="leadForm.controls.LeadTypeId.value"
          [namePropertyPath]="'Description'"
          [valuePropertyPath]="'Id'"
          (onChange)="setLeadTypeId($event * 1, true)"
          [hasError]="hasError"
          [errorKey]="'%ACTION_EDIT_LEAD_TYPE_ERROR_MESSAGE_RELATIONSHIP_MANAGEMENT%'"
        ></fi-input>

        @if (leadForm.controls.LeadTypeId.value === leadTypeOffer) {
          <fi-input
            type="SELECT"
            [readOnly]="!canEditFields"
            [enableSearch]="true"
            labelKey="%GENERAL_TEXT_CONSTRUCTION_TYPE%"
            [replaceKeys]="true"
            [options]="constructionTypes"
            [selectedOptionsOrValues]="leadForm.controls.ConstructionTypeId.value"
            [namePropertyPath]="'Description'"
            [valuePropertyPath]="'Id'"
            (onChange)="setConstructionTypeId($event * 1)"
          ></fi-input>
        }

        @if (leadForm.controls.LeadTypeId.value === leadTypeBrochure) {
          <fi-input type="MULTI_SELECT"
            labelKey="{{broschureLabelText}}"
            [enableSearch]="true"
            [multiLineOptionText]="true"
            [readOnly]="!canEditFields"
            [replaceKeys]="true"
            [showSelectedOnTop]="true"
            [placeholderKey]="'%REQUEST_DETAIL_EDIT_HEADER_ARTICLE_BROSCHURE_PLACEHOLDER%'"
            [selectedOptionsOrValues]="selectedItems"
            [options]="brochures"
            [namePropertyPath]="'text'"
            [valuePropertyPath]="'value'"
            [imagePropertyPath]="'image'"
            (onValuesChange)="onItemChange($event, 'brochure')"
            [hasError]="hasSampleAccessError"
            [errorKey]="'No access on request'"
          ></fi-input>
        }

        @if (leadForm.controls.LeadTypeId.value === leadTypeMuster) {
          <fi-input type="MULTI_SELECT"
            labelKey="{{musterLabelText}}"
            [enableSearch]="true"
            [replaceKeys]="true"
            [readOnly]="!canEditFields"
            [showSelectedOnTop]="true"
            [placeholderKey]="'%REQUEST_DETAIL_EDIT_HEADER_ARTICLE_SAMPLE_PLACEHOLDER%'"
            [selectedOptionsOrValues]="selectedItems"
            [options]="musters"
            [namePropertyPath]="'text'"
            [valuePropertyPath]="'value'"
            (onValuesChange)="onItemChange($event, 'muster')"
            [hasError]="hasSampleAccessError"
            [errorKey]="'No access on request'"
          ></fi-input>
        }

        @if (leadForm.controls.LeadTypeId.value === leadTypeAusschreibungstexte) {
          <fi-input type="MULTI_SELECT"
            labelKey="{{ausschreibungstexteLabelText}}"
            [enableSearch]="true"
            [replaceKeys]="true"
            [readOnly]="!canEditFields"
            [showSelectedOnTop]="true"
            [placeholderKey]="'%REQUEST_DETAIL_EDIT_HEADER_ARTICLE_TENDER_PLACEHOLDER%'"
            [selectedOptionsOrValues]="selectedItems"
            [options]="ausschreibungstextes"
            [namePropertyPath]="'text'"
            [valuePropertyPath]="'value'"
            (onValuesChange)="onItemChange($event, 'aussch')"
            [hasError]="hasSampleAccessError"
            [errorKey]="'No access on request'"
          ></fi-input>
        }

        @if (leadForm.controls.LeadTypeId.value === leadTypeCadDaten) {
          <fi-input type="MULTI_SELECT"
            labelKey="{{cadDateLabelText}}"
            [enableSearch]="true"
            [replaceKeys]="true"
            [readOnly]="!canEditFields"
            [showSelectedOnTop]="true"
            [placeholderKey]="'%REQUEST_DETAIL_EDIT_HEADER_ARTICLE_CAD_PLACEHOLDER%'"
            [selectedOptionsOrValues]="selectedItems"
            [options]="cadDatens"
            [namePropertyPath]="'text'"
            [valuePropertyPath]="'value'"
            (onValuesChange)="onItemChange($event, 'cadDaten')"
            [hasError]="hasSampleAccessError"
            [errorKey]="'No access on request'"
          ></fi-input>
        }

        <fi-input type="SELECT"
          [enableSearch]="true"
          labelKey="%REQUEST_CREATE_HEADLINE_LEADSOURCE%*"
          [replaceKeys]="true"
          [readOnly]="!canEditFields"
          [options]="leadSources"
          [selectedOptionsOrValues]="leadForm.controls.LeadSourceId.value"
          [namePropertyPath]="'Description'"
          [valuePropertyPath]="'Id'"
          (onChange)="leadForm.controls.LeadSourceId.setValue(+$event)"
          [hasError]="isInvalidForm('requestForm','LeadSourceId')"
        ></fi-input>

        @if (leadForm.controls.LeadTypeId.value === leadTypeOffer) {
          <fi-input
            [hasError]="leadForm?.touched && leadForm?.controls?.PLANER_CODE?.invalid"
            [readOnly]="!canEditFields"
            additionalContentPosition="START"
            labelKey="GENERAL_TEXT_PLANER_KOMPOSITION"
            [form]="leadForm"
            controlName="PLANER_CODE"
            [maxLength]="5"
            >
            <span class="code-text">N°</span>
          </fi-input>
        }

        <div class="tag-group">
          <fi-input
            [options]="shownPossibleTags"
            [namePropertyPath]="'Text'"
            [valuePropertyPath]="'Text'"
            [readOnly]="!canEditFields"
            [maxLength]="40"
            [enableSearch]="true"
            [clearOnEnterOrSelect]="true"
            type="SELECT"
            placeholderKey="REQUEST_DETAIL_HEADER_ADD_TAG_PLACEHOLDER"
            labelKey="REQUEST_DETAIL_OVERLAY_TAGS_LABEL"
            (onChange)="onAddTag($event)"
            (onEnterPressed)="onAddTag($event)"
            >
          </fi-input>

          @if (tags.length) {
            <div class="tags">
              @for (tag of tags; track tag; let i = $index) {
                <div class="tag">
                  <span>{{ tag.Text }}</span>
                  @if (tag.Owned && canEditFields) {
                    <mat-icon (click)="tags.splice(i, 1); updateTags();">close</mat-icon>
                  }
                </div>
              }
            </div>
          }
        </div>

      </div>

      @if (leadForm.controls.LeadTypeId.value !== leadTypeRelationshipManagement) {
        <div class="section-text margin">
          <span fiTranslation="REQUEST_DETAIL_ADDITONAL_ADDRESS"></span>
          <fi-checkbox class="checkbox" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="sameAsContactAddress"
            [disabled]="!canEditFields"
            (checkedChange)="onSameAsContactAddressChange()">
            <span class="text" fiTranslation="REQUEST_CREATE_SAME_CONSTUCTION_ADDRESS"></span>
          </fi-checkbox>
        </div>
        <div class="input-row">
          <fi-input [hasError]="leadForm?.touched && leadForm?.controls?.Commission?.invalid"
            [readOnly]="!canEditFields"
            labelKey="REQUEST_DETAIL_HEADLINE_ADDRESS_PROJECT_NAME" [form]="leadForm" controlName="Commission"
            class="form-input street">
          </fi-input>
          <fi-input [readOnly]="sameAsContactAddress || !canEditFields"
            [hasError]="leadForm?.touched && leadForm?.controls?.Address?.invalid"
            labelKey="REQUEST_DETAIL_HEADLINE_ADDRESS" [form]="leadForm" controlName="Address"
            class="form-input street">
          </fi-input>
          <div class="input-pair">
            <fi-input [readOnly]="sameAsContactAddress || !canEditFields"
              [hasError]="leadForm?.touched && leadForm?.controls?.ZipCode?.invalid"
              labelKey="REQUEST_CREATE_CONTACT_HEADLINE_ZIPCODE" [form]="leadForm" controlName="ZipCode"
              class="form-input postcode">
            </fi-input>
            <fi-input [readOnly]="sameAsContactAddress || !canEditFields"
              [hasError]="leadForm?.touched && leadForm?.controls?.City?.invalid"
              labelKey="REQUEST_CREATE_CONTACT_HEADLINE_CITY" [form]="leadForm" controlName="City"
              class="form-input place">
            </fi-input>
          </div>
          <fi-input
            labelKey="REQUEST_CREATE_CONTACT_HEADLINE_COUNTRY"
            type="SELECT"
            [enableSearch]="true"
            [placeholderKey]="'REQUEST_DETAIL_EDIT_HEADER_COUNTRY_PLACEHOLDER'"
            [readOnly]="sameAsContactAddress || !canEditFields"
            (onChange)="onCountryChange($event)"
            [namePropertyPath]="'Name'"
            [valuePropertyPath]="'IsoCode'"
            [selectedOptionsOrValues]="leadForm?.controls?.CountryCode?.value"
            [options]="resourceCountries"
          ></fi-input>
          @if (provinceCountryCodes.includes(leadForm?.controls?.CountryCode?.value)) {
            <fi-input
              labelKey="REQUEST_CREATE_CONTACT_HEADLINE_PROVINCE"
              type="SELECT"
              [enableSearch]="true"
              [placeholderKey]="'REQUEST_DETAIL_EDIT_HEADER_PROVINCE_PLACEHOLDER'"
              [readOnly]="sameAsContactAddress || !canEditFields"
              (onChange)="leadForm?.controls?.ProvinceCode?.setValue($event)"
              [namePropertyPath]="'Text'"
              [valuePropertyPath]="'Code'"
              [selectedOptionsOrValues]="leadForm?.controls?.ProvinceCode?.value"
              [options]="resourceProvinces"
            ></fi-input>
          }
        </div>
      }


      @if (showSharedLeadBox) {
        <fi-shared-lead-checkbox
          [checked]="isShared"
          (checkedChange)="isShared = $event; onChangeSharedStatus()"
        ></fi-shared-lead-checkbox>
      }
    </div>
  </div>

  <div class="footer">
    <button (click)="onSubmit()">
      <span fiTranslation="ALT_TEXT_SAVE_PROFILE"></span>
    </button>
  </div>
</div>
